import React, { useState } from 'react';
import './LevelGradeSelectionScreen.css';

const GradeSelectionScreen = ({ selectedLevel, onSelect, onBack }) => {
  const [selectedGrade, setSelectedGrade] = useState(null);

  const grades = [1, 2, 3];

  const handleGradeSelect = (grade) => {
    setSelectedGrade(grade);
    // الانتقال تلقائياً إلى شاشة قائمة المراجعات
    onSelect(selectedLevel, grade);
  };

  const getGradeLabel = (grade) => {
    const labels = { 1: 'الأول', 2: 'الثاني', 3: 'الثالث' };
    return labels[grade] || `صف ${grade}`;
  };

  const getLevelLabel = () => {
    return selectedLevel === 'middle' ? 'المرحلة المتوسطة' : 'المرحلة الثانوية';
  };

  return (
    <div className="level-grade-screen">
      <div className="level-grade-container" style={{ position: 'relative' }}>
        <div className="selection-header">
          {onBack && (
            <button className="back-button ripple-effect magnetic-button" onClick={onBack}>
              ← رجوع
            </button>
          )}
          <h1 className="selection-title">اختر الصف</h1>
        </div>

        <div className="selection-content">
          <div className="level-info" style={{ 
            textAlign: 'center', 
            marginBottom: '30px',
            padding: '15px',
            background: 'rgba(212, 175, 55, 0.1)',
            borderRadius: '12px',
            border: '1px solid rgba(212, 175, 55, 0.3)'
          }}>
            <p style={{ 
              color: '#FFFFFF', 
              fontSize: '18px', 
              fontWeight: '600',
              margin: 0 
            }}>
              {getLevelLabel()}
            </p>
          </div>

          <div className="grade-cards">
            {grades.map((grade, index) => (
              <div
                key={grade}
                className={`grade-card ripple-effect stagger-item ${selectedGrade === grade ? 'selected bounce-light' : ''}`}
                onClick={() => handleGradeSelect(grade)}
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
              >
                <div className="card-label">الصف {getGradeLabel(grade)}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="level-grade-footer">
          <p>مدير المدرسة: محمد نصر الدين</p>
        </div>
      </div>
    </div>
  );
};

export default GradeSelectionScreen;

